import type { QueryFunctionContext } from '@tanstack/react-query';
import { getLearningLoop } from '@simplywallst/services';

export const QUERY_KEY = 'LEARNING_CONTENT' as const;

export const queryFn = async ({
  queryKey: [_keyof, contentKey],
}: QueryFunctionContext<[string, string]>) => {
  const response = await getLearningLoop(contentKey);
  return response.data;
};
